// extracted by mini-css-extract-plugin
export default {"heading":"_6iifEcTu0bxOFKcvFGuzXW"};